import AppConfig from '../config';

const EnvService = {
    Init: () => {
        EnvService.InitStyles();
        EnvService.SetColorScheme();
    },
    InitStyles: () => {
        import(
            `../targets/${
                process.env?.REACT_APP_ENVIRONMENT || 'default'
            }/assets/custom.scss`
        )
            .then(() => {
                console.log('Custom theme loaded');
            })
            .catch((err) => console.error('Failed to load custom theme', err));
    },
    // mode: light | dark
    SetColorScheme: (mode = 'light') => {
        const colors = AppConfig?.colorScheme[mode] || {};
        if (!(Object?.values(colors)?.length > 0)) {
            console.error('Unable to set color scheme');
            return;
        }
        Object?.keys(colors)?.forEach((key) => {
            document.documentElement.style.setProperty(
                `--${key?.replaceAll('_', '-')}`,
                `${colors[key]}`
            );
        });
    }
};

export default EnvService;
